interface mxISR {
    minLimit: number;
    maxLimit: number;
    fixedFee: number;
    percent: number;
}

export let defaultMxISR:mxISR[] = [
    {minLimit: 0.01, maxLimit: 10135.11, fixedFee: 0, percent: 1.92},
    {minLimit: 10135.12, maxLimit: 86022.11, fixedFee: 194.59, percent: 6.40},
    {minLimit: 86022.12, maxLimit: 151176.19, fixedFee: 5051.37, percent: 10.88},
    {minLimit: 151176.20, maxLimit: 175735.66, fixedFee: 12140.13, percent: 16.00},
    {minLimit: 175735.67, maxLimit: 210403.69, fixedFee: 16069.64, percent: 17.92},
    {minLimit: 210403.70, maxLimit: 424353.97, fixedFee: 22282.14, percent: 21.36},
    {minLimit: 424353.98, maxLimit: 668840.14, fixedFee: 67981.92, percent: 23.52},
    {minLimit: 668840.15, maxLimit: 1276925.98, fixedFee: 125485.07, percent: 30.00},
    {minLimit: 1276925.99, maxLimit: 1702567.97, fixedFee: 307910.81, percent: 32.00},
    {minLimit: 1702567.98, maxLimit: 5107703.92, fixedFee: 444116.23, percent: 34.00},
    {minLimit: 5107703.93, maxLimit: 999999999.99, fixedFee: 1601862.46, percent: 35.00},
]

export let defaultMxMonthISR:mxISR[] = [
    {minLimit: 0.01, maxLimit: 844.59, fixedFee: 0, percent: 1.92},
    {minLimit: 844.60, maxLimit: 7168.51, fixedFee: 16.22, percent: 6.40},
    {minLimit: 7168.52, maxLimit: 12598.02, fixedFee: 420.95, percent: 10.88},
    {minLimit: 12598.03, maxLimit: 14644.64, fixedFee: 1011.68, percent: 16.00},
    {minLimit: 14644.65, maxLimit: 17533.64, fixedFee: 1339.14, percent: 17.92},
    {minLimit: 17533.65, maxLimit: 35362.83, fixedFee: 1856.84, percent: 21.36},
    {minLimit: 35362.84, maxLimit: 55736.68, fixedFee: 5665.16, percent: 23.52},
    {minLimit: 55736.69, maxLimit: 106410.50, fixedFee: 10457.09, percent: 30.00},
    {minLimit: 106410.51, maxLimit: 141880.66, fixedFee: 25659.23, percent: 32.00},
    {minLimit: 141880.67, maxLimit: 425641.99, fixedFee: 37009.69, percent: 34.00},
    {minLimit: 425642.00, maxLimit: 999999999.99, fixedFee: 133488.54, percent: 35.00},
]

export const UMA = {
    daily: 117.31,
    monthly: 3566.22,
    anually: 42794.64,
};
